import React from "react";
import SVGEasyApproval from "../../../svg/SVGEasyApproval";
import SVGAvailOffer from "../../../svg/SVGAvailOffer";
import SVGNoCardRequired from "../../../svg/SVGNoCardRequired";
import SVGPayIn from "../../../svg/SVGPayIn";

const CheckEligibility = ({
  mobileNumber,
  setMobileNumber,
  mobileNumberErrorMsg,
  onSubmit,
}) => {
  return (
    <>
      <h2 id="check-eligibility">Check Eligibility</h2>
      <div className="static-features">
        <div class="cardless-row">
          <div class="cardless-column">
            <SVGAvailOffer />
            <span>Avail offers</span>
          </div>
          <div class="cardless-column">
            <SVGNoCardRequired />
            <span>No card needed</span>
          </div>
        </div>
        <div class="cardless-row">
          <div class="cardless-column">
            <SVGEasyApproval />
            <span>Easy approval</span>
          </div>
          <div class="cardless-column">
            <SVGPayIn />
            <span>Pay - in - 3/6/9/12</span>
          </div>
        </div>
      </div>

      <h3>Check eligibility with just your mobile number</h3>

      <div className="check-eligibility-section">
        <div className="form-group d-inline-block">
          <span class="border-end country-code px-2">+91</span>
          <input
            className="form-control"
            type="tel"
            id="mobileNumber"
            name="mobileNumber"
            placeholder="Enter mobile no."
            maxLength="10"
            autoComplete="off"
            autoFocus={true}
            value={mobileNumber}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setMobileNumber(value);
            }}
          />
        </div>

        <button className="btn btn-green col-3" onClick={onSubmit}>
          Check Eligible Offers
        </button>
      </div>
      {mobileNumberErrorMsg && (
        <span className="text-red"> {mobileNumberErrorMsg} </span>
      )}
      <div className="bottom-icon-section">{/* add footer icons */}</div>
    </>
  );
};

export default CheckEligibility;
